export enum DatePickerType {
  day = 'day',
  month = 'month',
  year = 'year'
}
